import styled from 'styled-components'

interface IBudgetIntervalSelectStyledProps {}

export const BudgetIntervalSelectStyled = styled.div<IBudgetIntervalSelectStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
